<template>
	<p class="text-general text-padding-left">Si ya eres cliente de nosotros, continua navegando por nuestro sitio y descubre más ofertas. Si eres nuevo en LASDDI por favor llena los datos y podrás recibir en tu correo el descuento.</p>

	<div class="row">
		<div class="col-sm-6 divider-right">
			<div class="col-sm-12">
				<form class="form-horizontal">
					<div class="col-sm-offset-3 col-sm-9" style="padding-right: 0px;">
					</div>
				</form>
			</div>
			
			<div class="form-group"> 
			    <div class="col-sm-offset-3 col-sm-9">
			      <button type="button" class="btn btn-black btn-lg" v-link="{ path: '/registro' }">Registrarme</button>
			    </div>
			</div>
		</div>
		<div class="col-sm-6">
			<login></login>
		</div>
	</div>
</template>

<script>
import Login from '../Login.vue';

export default{
	components: {
		Login,
	}
}
</script>


// WEBPACK FOOTER //
// Shopping-cart-login.vue?232f7d22